const useFormFlow = (
  fieldRefs: any,
  flowSteps: string[],
  onComplete?: Function,
  onCancel?: Function
) => {
  const handleStart = () => () => {
    fieldRefs[flowSteps[0]]?.focus();
  };

  const handleNext = (currentStep: string) => () => {
    const currentIndex = flowSteps.indexOf(currentStep);

    // Thoát ra sớm nếu không tìm thấy step hiện tại
    if (currentIndex === -1) return;

    // Nếu là bước cuối cùng, gọi onComplete nếu có
    if (currentIndex === flowSteps.length - 1) {
      onComplete?.();
    } else {
      // Focus vào bước tiếp theo
      fieldRefs[flowSteps[currentIndex + 1]]?.focus();
    }
  };

  const handleBack = (currentStep: string) => () => {
    const currentIndex = flowSteps.indexOf(currentStep);

    // Không thực hiện gì nếu không tìm thấy bước hiện tại
    if (currentIndex === -1) return;

    // Nếu là đầu tiên thì gọi hàm onCancel
    if (currentIndex === 0) {
      onCancel?.();
    } else {
      // Focus vào bước trước đó
      fieldRefs[flowSteps[currentIndex - 1]]?.focus();
    }
  };

  const handleNextLoop = (currentStep: string) => () => {
    const currentIndex = flowSteps.indexOf(currentStep);

    // Thoát ra sớm nếu không tìm thấy step hiện tại
    if (currentIndex === -1) return;

    // Nếu là bước cuối cùng thì vòng lại bước đầu tiên
    if (currentIndex === flowSteps.length - 1) {
      fieldRefs[flowSteps[0]]?.focus();
    } else {
      // Focus vào bước tiếp theo
      fieldRefs[flowSteps[currentIndex + 1]]?.focus();
    }
  };

  const handleBackLoop = (currentStep: string) => () => {
    const currentIndex = flowSteps.indexOf(currentStep);

    // Thoát ra sớm nếu không tìm thấy step hiện tại
    if (currentIndex === -1) return;

    // Nếu là bước đầu tiền thì vòng lại bước cuối cùng
    if (currentIndex === 0) {
      fieldRefs[flowSteps[flowSteps.length - 1]]?.focus();
    } else {
      // Focus vào bước trước đó
      fieldRefs[flowSteps[currentIndex - 1]]?.focus();
    }
  };

  return {
    handleStart,
    handleNext,
    handleBack,
    handleNextLoop,
    handleBackLoop,
  };
};

export default useFormFlow;
